import styled from 'styled-components';
import { localizePercentageValue } from 'utils/i18nHelpers';
import { Cell } from './Cell';

export const PERCENT_DATA_TEST = 'campaigns-percent-count';
const COLUMN_ID = 'percent';

type PercentageCellProps = {
  count: number;
  rowIndex: number;
};

const Percent = styled.div`
  align-self: flex-end;
`;

export const PercentageCell = ({ count, rowIndex }: PercentageCellProps) => {
  const localizedPercentageValue = localizePercentageValue(count, false);

  return (
    <Cell data-test={PERCENT_DATA_TEST} columnId={COLUMN_ID} $rowIndex={rowIndex}>
      <Percent>{localizedPercentageValue}</Percent>
    </Cell>
  );
};
